export default __webpack_public_path__ + "static/media/vegetal_bio_spf_30_sunscreen_lotion_100_ml_0_0.bd729971.dib";